export default [
  // {
  //   url: "/apps/email",
  //   name: "Email",
  //   slug: "email",
  //   icon: "MailIcon",
  //   i18n: "Email",
  // },
  {
    url: "/dashboard",
    name: "Dashboard",
    icon: "HomeIcon",
    i18n: "Dashboard",
  },
  {
    header: "Manajemen",
    icon: "LayersIcon",
    i18n: "Management",
    items: [
      {
        url: "/cash-book",
        name: "Buku Kas",
        slug: "cash-book",
        icon: "BookIcon",
        i18n: "CashBook",
        submenu: [
          {
            url: "/cashbook/petty-cash",
            name: "PettyCash",
            slug: "petty-cash",
            i18n: "PettyCash",
          },
          {
            url: "/cashbook/big-cash",
            name: "BigCash",
            slug: "big-cash",
            i18n: "BigCash",
          },
          {
            url: "/cashbook/mixed-cash",
            name: "MixedCash",
            slug: "mixed-cash",
            i18n: "MixedCash",
          },
        ],
      },
      {
        url: "/cash-book-temporary",
        name: "Bon Sementara",
        slug: "cash-book-temporary",
        icon: "RepeatIcon",
        i18n: "CashBookTemporary",
      },
      {
        url: "/bank",
        name: "Bank",
        slug: "bank",
        icon: "CreditCardIcon",
        i18n: "Bank",
      },
    ],
  },
  {
    header: "Pengaturan",
    icon: "LayersIcon",
    i18n: "Settings",
    items: [
      {
        url: "/profile",
        name: "Akun Profil",
        slug: "profile",
        icon: "UserIcon",
        i18n: "Profile",
      },
      {
        url: "/company-accounts",
        name: "Detail Perusahaan",
        slug: "company-accounts",
        icon: "BriefcaseIcon",
        i18n: "CompanyAccount",
      },
      {
        url: "/company",
        name: "Perusahaan",
        slug: "company",
        icon: "LayersIcon",
        i18n: "Company",
      },
      {
        url: "/users",
        name: "Pengguna",
        slug: "Pengguna",
        icon: "UsersIcon",
        i18n: "Pengguna",
      },
    ],
  },
];

